/**
 * @generated SignedSource<<01a628d2af31a5c7eb78a54a7a601a0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type SpecialitySort = "ID" | "NAME" | "PRACTITIONER_TYPE" | "CATEGORY" | "TRANSLATION_KEY" | "CONNECT_ONLY" | "DELETED_AT" | "UPDATED_AT" | "CREATED_AT" | "PHASED_OUT_AT" | "RANDOM" | "%future added value";
export type SpecialityOrdering = {
  sort: SpecialitySort;
  direction: SortDirection;
};
export type SpecialityFilter = {
  search?: string | null;
  where?: SpecialityWhere | null;
};
export type SpecialityWhere = {
  id?: IDFilter | null;
  name?: StringFilter | null;
  practitionerType?: StringFilter | null;
  category?: StringFilter | null;
  translationKey?: StringFilter | null;
  connectOnly?: BooleanFilter | null;
  deletedAt?: TimeFilter | null;
  updatedAt?: TimeFilter | null;
  createdAt?: TimeFilter | null;
  phasedOutAt?: TimeFilter | null;
  userSpecialities?: UserSpecialityWhere | null;
  or?: SpecialityWhere | null;
  and?: SpecialityWhere | null;
};
export type IDFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
};
export type StringFilter = {
  isNullOrEmpty?: boolean | null;
  isEmpty?: boolean | null;
  isNull?: boolean | null;
  notNullOrEmpty?: boolean | null;
  notEmpty?: boolean | null;
  notNull?: boolean | null;
  equalTo?: string | null;
  notEqualTo?: string | null;
  in?: ReadonlyArray<string> | null;
  notIn?: ReadonlyArray<string> | null;
  startWith?: string | null;
  notStartWith?: string | null;
  endWith?: string | null;
  notEndWith?: string | null;
  contain?: string | null;
  notContain?: string | null;
  startWithStrict?: string | null;
  notStartWithStrict?: string | null;
  endWithStrict?: string | null;
  notEndWithStrict?: string | null;
  containStrict?: string | null;
  notContainStrict?: string | null;
};
export type BooleanFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: boolean | null;
  notEqualTo?: boolean | null;
};
export type TimeFilter = {
  isNull?: boolean | null;
  notNull?: boolean | null;
  equalTo?: any | null;
  notEqualTo?: any | null;
  lessThan?: any | null;
  lessThanOrEqualTo?: any | null;
  moreThan?: any | null;
  moreThanOrEqualTo?: any | null;
};
export type UserSpecialityWhere = {
  id?: IDFilter | null;
  userId?: IDFilter | null;
  createdAt?: TimeFilter | null;
  speciality?: SpecialityWhere | null;
  or?: UserSpecialityWhere | null;
  and?: UserSpecialityWhere | null;
};
export type profileSpecialitiesQuery$variables = {
  first: number;
  after?: string | null;
  ordering?: ReadonlyArray<SpecialityOrdering> | null;
  filter?: SpecialityFilter | null;
};
export type profileSpecialitiesQuery$data = {
  readonly specialities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly practitionerType: string;
        readonly category: string;
        readonly translationKey: string;
        readonly connectOnly: boolean | null;
        readonly deletedAt: any | null;
        readonly updatedAt: any | null;
        readonly createdAt: any | null;
        readonly phasedOutAt: any | null;
      } | null;
    } | null> | null;
  };
};
export type profileSpecialitiesQuery = {
  variables: profileSpecialitiesQuery$variables;
  response: profileSpecialitiesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ordering"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "ordering",
        "variableName": "ordering"
      }
    ],
    "concreteType": "SpecialityConnection",
    "kind": "LinkedField",
    "name": "specialities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SpecialityEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Speciality",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "practitionerType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "translationKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "connectOnly",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phasedOutAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "profileSpecialitiesQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "profileSpecialitiesQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7a756ea85af1e3ac238243c421bb0e26",
    "id": null,
    "metadata": {},
    "name": "profileSpecialitiesQuery",
    "operationKind": "query",
    "text": "query profileSpecialitiesQuery(\n  $first: Int!\n  $after: String\n  $ordering: [SpecialityOrdering!]\n  $filter: SpecialityFilter\n) {\n  specialities(first: $first, after: $after, ordering: $ordering, filter: $filter) {\n    edges {\n      node {\n        id\n        name\n        practitionerType\n        category\n        translationKey\n        connectOnly\n        deletedAt\n        updatedAt\n        createdAt\n        phasedOutAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5586f126a8c8682060477b9581f0a8d0";

export default node;
